import { buildGroupTraits, buildIdentifyTraits, isImpersonating } from './analytics-utility';

class PendoClass {
  static initialized = false;

  buildPendoIdentifyData(userId, sellerId, userInfo, sellerInfo) {
    const visitorData = buildIdentifyTraits(sellerId, userInfo, sellerInfo);
    visitorData.id = userId;

    const accountData = buildGroupTraits(sellerId, sellerInfo);
    accountData.id = sellerId;

    return {
      visitor: visitorData,
      account: accountData,
    };
  }

  initialize(identifyData) {
    if (!window.pendo || Pendo.initialized) {
      return;
    }

    window.pendo.initialize(identifyData);

    Pendo.initialized = true;
  }

  identifyUser(userId, sellerId, userInfo, sellerInfo) {
    if (!window.pendo || isImpersonating()) {
      return;
    }
    const identifyData = this.buildPendoIdentifyData(userId, sellerId, userInfo, sellerInfo);

    this.initialize(identifyData);
    window.pendo.identify(identifyData);
  }

  // oxlint-disable-next-line no-empty-function
  trackPage() {}

  // oxlint-disable-next-line no-empty-function
  trackEvent() {}
}

export const Pendo = new PendoClass();
